import { render, staticRenderFns } from "./PerSearch.vue?vue&type=template&id=44bc7628&scoped=true"
import script from "./PerSearch.vue?vue&type=script&lang=js"
export * from "./PerSearch.vue?vue&type=script&lang=js"
import style0 from "./PerSearch.vue?vue&type=style&index=0&id=44bc7628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc7628",
  null
  
)

export default component.exports